import { Component, Input, Output, EventEmitter, OnInit, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, FormBuilder, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

import { SessionStorageService, PageContentService, ParamService, ParameterConfigService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';
import { ParamInfo, CodedLookup } from '../../core/index.model';
import { ParamType } from '../../core/enumtype';

@Component({
    selector: 'pnx-parameter',
    templateUrl: './parameter.control.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ParameterControl), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => ParameterControl), multi: true }
    ]
})
export class ParameterControl implements OnInit, ControlValueAccessor, Validator {
    @Input() labelId: string = '';
    @Input() defaultLabel: string = '';
    @Input() placeholderId: string = '';
    @Input() defaultPlaceholder: string = '';
    @Input() pagecontent: PageContent;

    @Input('value') _value;
    @Input() paramID: number;
    @Input() label: string = '';
    @Input() placeholder: string = '';
    @Input() mandatory: boolean = false;
    @Input() readonly: boolean = false;
    @Input() ctrlcontainerstyle: string = 'row';
    @Input() ctrlstyle: string = '';
    @Input() labelstyle: string = 'control-label';
    @Input() istextbox: boolean = false;
    @Input() control: FormControl;
    @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

    paramType: ParamType;
    paramInfo: ParamInfo;
    paramValue = new FormControl();
    codedLookup: CodedLookup[] = [];

    constructor(private paramService: ParamService,
        private pageContentService: PageContentService,
        private storageService: SessionStorageService,
        private paramConfigService: ParameterConfigService
    ) { }

    ngOnInit() {
        if (this.pagecontent) {
            if (!this.pageContentService.pageContent) {
                this.pageContentService.pageContent = this.pagecontent;
            }
        }

        if (this.paramID) {
            this.paramInfo = this.paramConfigService.GetSystemParamInfo(this.paramID);
            if (this.paramInfo) {
                this.paramType = this.paramInfo.ParamType ? Number.parseInt(this.paramInfo.ParamType) : null;

                switch (this.paramType) {
                    case (ParamType.MultiSelectDropdown): {
                        var str = this.paramInfo.DefaultValue;
                        var str_array = str.split(',');
                        if (str) {
                            for (var i = 0; i < str_array.length; i++) {
                                if (str_array[i] != 'All') {
                                    str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
                                    this.codedLookup.push(this.paramInfo.CodedLookup.find(item => item.CodeValue === str_array[i]));
                                }
                            }
                        }

                        break;
                    }
                    case (ParamType.Dropdown): {
                        this.codedLookup = this.paramInfo.CodedLookup;
                        this.writeValue(this.paramInfo.DefaultValue);
                        break;
                    }
                    case (ParamType.TextBox): {
                        this.writeValue(this.paramInfo.DefaultValue);
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        }
    }

    ngOnChanges(Changes: SimpleChanges) {
        this.propagateChange(this.value);
        if (this.control) {
            this.validate(this.control);
        }

        let labelValue = (this.labelId) ? this.pageContentService.getKeyTxt(this.labelId, this.storageService.getLang()) : this.label;
        let placeHolderValue = (this.placeholderId) ? this.pageContentService.getKeyTxt(this.placeholderId, this.storageService.getLang()) : this.placeholder;

        this.label = (labelValue) ? labelValue : this.defaultLabel;
        this.placeholder = (placeHolderValue) ? placeHolderValue : this.defaultPlaceholder;
    }

    onValueChange() {
        this.value = this.paramValue.value;
        this.onChange.emit(this.paramValue.value);
    }

    showMultiSelectDropdown(): boolean {
        if (this.paramType == ParamType.MultiSelectDropdown) {
            return true;
        }
        else {
            return false;
        }
    }

    showDropdown(): boolean {
        if (this.paramType == ParamType.Dropdown) {
            return true;
        }
        else {
            return false;
        }
    }

    showTxt(): boolean {
        if (this.paramType == ParamType.TextBox) {
            return true;
        }
        else {
            return false;
        }
    }

    onTextChange() {
        this.value = this.paramValue.value;
    }

    propagateChange = (_: any) => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    writeValue(value): void {
        this.value = value;
        this.paramValue.setValue(this.value);
    }

    registerOnChange(fn): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn): void { }

    setDisabledState(isDisabled: boolean): void { }

    public validate(parentControl: AbstractControl): { [key: string]: any } {

        const val = parentControl.value;

        if (this.mandatory) {

            this.paramValue.setValidators(Validators.required);
            parentControl.setValidators(Validators.required);

            if (!parentControl.value) {
                parentControl.setValue(null);
            }

            if (!val) {
                return { valid: false };
            }
        }
        else {

            this.paramValue.clearValidators();
            parentControl.clearValidators();

            if (!parentControl.value) {
                parentControl.setValue(null);
            }
        }

        return null;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/parameter.control.ts